// eslint-disable-next-line import/prefer-default-export
export enum SizeThresholds {
  BCLogo = 450,
  Availability = 280
}
